import { useRouter } from 'next/router'
import getConfigVariable from './getConfigVariable'

const stage = getConfigVariable('STAGE')

export default function getDomainName() {
  // todo: make from this function custom hook
  // eslint-disable-next-line
  const router = useRouter()

  switch (stage) {
    case 'development':
      return 'https://development.doctify.com'
    case 'staging':
      return 'https://staging.doctify.com'
    case 'production':
      if (router.pathname === '/') {
        return 'https://www.doctify.com'
      }
      return 'https://doctify.com'
    default:
      return ''
  }
}
